import {
    type ContactEmailBounceFields,
    getActiveContactEmailBounce,
} from '@common/utils/contactEmailBounce';
import { Alert, AlertTitle, type SxProps, type Theme, Typography } from '@mui/material';
import { convertUTCDateToEST } from '@/utils/datetime';

interface Props {
    contact: ContactEmailBounceFields | null | undefined;
    sx?: SxProps<Theme>;
}

export default function ContactEmailBounceAlert({ contact, sx }: Props) {
    const bounce = getActiveContactEmailBounce(contact);
    if (!contact || !bounce) return null;

    const bouncedAt = convertUTCDateToEST(bounce.bouncedAt, 'MMM d, yyyy h:mm a');

    // inline-size containment keeps long bounce reasons from widening shrink-to-fit parents;
    // the alert fills the width set by the surrounding content and wraps within it
    return (
        <Alert
            severity="error"
            sx={[
                { width: '100%', boxSizing: 'border-box', contain: 'inline-size' },
                ...(Array.isArray(sx) ? sx : [sx]),
            ]}
        >
            <AlertTitle>Intake email bounced</AlertTitle>
            <Typography variant="body2">
                The intake email to {contact.contactEmail} could not be delivered
                {bouncedAt ? ` on ${bouncedAt}` : ''}. Confirm the address with the client, update
                the contact, and resend the intake email.
            </Typography>
            {bounce.reason && (
                <Typography variant="body2" sx={{ mt: 1, wordBreak: 'break-word' }}>
                    Reason: {bounce.reason}
                </Typography>
            )}
        </Alert>
    );
}
